import React, { Component } from "react";

//IMPORT IMAGES
import beforeShapefooterImg from '../../frontend/assets/img/shape/before-shape-2.png';
import footerVectorImg from '../../frontend/assets/img/Jainism/floatin yello svg.svg';
import mainLogoImg from '../../frontend/assets/img/Jainism/mainlogo.svg';
import mobileImage from '../../frontend/assets/img/Jainism/downloadphone.png';
import { BASEURL } from "../../Global";
class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            themeSetting: [],
            isRegister: false,
        };
    }
    componentDidMount() {
        this.fetchThemeSetting()
        this.VisibleRegistration()
    }
    async VisibleRegistration() {
        try {
            await fetch(`${BASEURL}/themesettingswithoutauthdate`, {
                method: "GET",
                headers: {
                    Accept: 'application/json',
                }
            })
                .then(response => {
                    if (response.status === 200) {
                        response.json().then(responseJson => {
                            if (responseJson) {
                                this.setState({ isRegister: responseJson?.result })
                            } else {
                                // console.log("Data Not Found !!")
                            }
                        })
                    } else {
                        // console.log("Something Went Wrong !!")
                    }
                })
                .catch((error) => console.error(error));
        } catch (e) {
            console.log("ERROR", e)
        }
    }
    async fetchThemeSetting() {
        try {
            await fetch(`${BASEURL}/themesettingswithoutauth`, {
                method: "GET",
                headers: {
                    Accept: 'application/json',
                }
            })
                .then(response => {
                    if (response.status === 200) {
                        response.json().then(responseJson => {
                            if (responseJson.data) {
                                this.setState({ themeSetting: responseJson.data[0] })
                            } else {
                                // console.log("Data Not Found !!")
                            }
                        })
                    } else {
                        // console.log("Something Went Wrong !!")
                    }
                })
                .catch((error) => console.error(error));
        } catch (e) {
            console.log("ERROR", e)
        }
    }
    render() {
        return (
            <React.Fragment>
                <footer className="footer-wrapper footer-layout2 abs-footer">
                    <div className="shape-before"><img src={beforeShapefooterImg} alt="shape" /></div>
                    <div className="shape-mockup movingX d-none d-hd-block footer-vector" data-bottom="37%" data-left="6%"
                        style={{ width: "10%" }}><img src={footerVectorImg} alt="shapes" /></div>

                    <div className="widget-area">
                        <div className="container">
                            <div className="row ">
                                <div className="col-xl-4 col-md-6 wow fadeInUp abs1" data-wow-delay="0.1s">
                                    <div className="widget footer-widget">
                                        <div className="">
                                            <div className="about-logo">
                                                <a href="index.html">
                                                    <img src={mainLogoImg} />
                                                </a>
                                            </div>
                                            <p className="about-text">“My Jainism” - Ek Sanskar Mandir is a non-profit organization who
                                                is working to imbibe Jainism
                                                values along with Basic moral values into the children
                                                in the age group of 5 to 15 years. </p>
                                            <div className="multi-social">
                                                <a href="#"><i className="fab fa-facebook-f"></i></a>
                                                <a href="#"><i className="fab fa-instagram"></i></a>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <section className="mobile-footer">
                                    <div className="col-xl-auto col-md-6 wow fadeInUp abs1" data-wow-delay="0.1s">
                                        <div className="widget footer-widget widget_nav_menu">
                                            <div className="vs-mobile-menu">
                                                <ul>
                                                    <li className="menu-item-has-children vs-item-has-children">
                                                        <a href="#" className="vs-mean-expand">
                                                            <h4 className="widget_title">Quick Links</h4>
                                                        </a>
                                                        <ul className="sub-menu vs-submenu" style={{ display: 'none' }}>

                                                            <li><a href={process.env.PUBLIC_URL + "/"}>Home</a></li>
                                                            <li><a href={process.env.PUBLIC_URL + "/about-us"}>About Us</a></li>
                                                            <li><a href={process.env.PUBLIC_URL + "/contact-us"}>Contact</a></li>
                                                            {this.state.isRegister && <li><a href={process.env.PUBLIC_URL + "/new-registration"}>Registration</a></li>}
                                                            <li><a href={process.env.PUBLIC_URL + "/gallary"}>Gallery</a></li>
                                                            <li><a href={process.env.PUBLIC_URL + "/modules"}>Modules</a></li>
                                                            <li><a href={process.env.PUBLIC_URL + "/privacy-policy"}>Privacy Policy</a></li>
                                                            <li><a href={process.env.PUBLIC_URL + "/terms-condition"}>Terms & Conditions</a></li>
                                                        </ul>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-xl-auto col-md-6 wow fadeInUp abs1" data-wow-delay="0.1s">
                                        <div className="widget footer-widget widget_nav_menu">
                                            <div className="vs-mobile-menu">
                                                <ul>
                                                    <li className="menu-item-has-children vs-item-has-children">
                                                        <a href="#" className="vs-mean-expand">
                                                            <h4 className="widget_title">Contact Us</h4>
                                                        </a>
                                                        <ul className="sub-menu vs-submenu" style={{ display: 'none' }}>
                                                            <li>
                                                                <p className="footer-info"><i className="fas fa-map-marker-alt"></i>{this.state.themeSetting?.address}</p>
                                                            </li>
                                                            <li>
                                                                <p className="footer-info"><i className="fas fa-envelope"></i><a href={`mailto:${this.state.themeSetting?.email}`}> {this.state.themeSetting?.email}</a></p>
                                                            </li>
                                                            <li>
                                                                <p className="footer-info"><i className="fas fa-phone-alt"></i><a href={`tel:${this.state.themeSetting?.mobile}`}>{this.state.themeSetting?.mobile}</a></p>
                                                            </li>

                                                        </ul>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-xl-auto col-md-6 wow fadeInUp abs1" data-wow-delay="0.1s">
                                        <div className="widget footer-widget widget_nav_menu">
                                            <div className="vs-mobile-menu">
                                                <ul>
                                                    <li className="menu-item-has-children vs-item-has-children">
                                                        <a href="#" className="vs-mean-expand download-expand">
                                                            <h4 className="widget_title">Download our<br /> Application</h4>
                                                        </a>
                                                   <ul className="download-icons" style={{ display: 'none' }}>
    <li style={{ listStyle: 'none' }}>
        <a 
            href="https://play.google.com/store/apps/details?id=com.myjainism" 
            target="_blank" 
            rel="noopener noreferrer"
        >
            <div className="download android">
                <i className="fa-brands fa-google-play icon-download"></i>
                <h5 className="df">Download from</h5>
                <h5 className="dfn">Google Play</h5>
            </div>
        </a>
    </li>
    <li style={{ listStyle: 'none' }}>
        <a 
            href="https://apps.apple.com/in/app/my-jainism/id6749439504" 
            target="_blank" 
            rel="noopener noreferrer"
        >
            <div className="download apple">
                <i className="fa-brands fa-apple icon-download"></i>
                <h5 className="df">Download from</h5>
                <h5 className="dfn">App Store</h5>
            </div>
        </a>
    </li>
</ul>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>

                                    </div>
                                </section>



                                <div className="col-xl-auto col-md-6 wow fadeInUp abs1 desktop-footer" data-wow-delay="0.1s">
                                    <div className="widget footer-widget widget_nav_menu">
                                        <h4 className="widget_title">Quick Links</h4>
                                        <ul className="menu">
                                            <li><a href={process.env.PUBLIC_URL + "/"}>Home</a></li>
                                            <li><a href={process.env.PUBLIC_URL + "/about-us"}>About Us</a></li>
                                            <li><a href={process.env.PUBLIC_URL + "/contact-us"}>Contact</a></li>
                                            {this.state.isRegister && <li><a href={process.env.PUBLIC_URL + "/new-registration"}>Registration</a></li>}
                                            <li><a href={process.env.PUBLIC_URL + "/gallary"}>Gallery</a></li>
                                            {/* <li><a href={process.env.PUBLIC_URL + "/modules"}>Modules</a></li> */}
                                            <li><a href={process.env.PUBLIC_URL + "/privacy-policy"}>Privacy Policy</a></li>
                                            <li><a href={process.env.PUBLIC_URL + "/terms-condition"}>Terms & Conditions</a></li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="col-xl-auto col-md-6 wow fadeInUp abs1 desktop-footer" data-wow-delay="0.1s">
                                    <div className="widget footer-widget">
                                        <h3 className="widget_title">Contact Us</h3>
                                        <div className="vs-widget-contact">
                                            <p className="footer-info"><i className="fas fa-map-marker-alt"></i>{this.state.themeSetting?.address}</p>
                                            <p className="footer-info"><i className="fas fa-envelope"></i><a href={`mailto:${this.state.themeSetting?.email}`}> {this.state.themeSetting?.email}</a>
                                            </p>
                                            <p className="footer-info"><i className="fas fa-phone-alt"></i><a href={`tel:${this.state.themeSetting?.mobile}`}>{this.state.themeSetting?.mobile}</a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-auto col-md-6 wow fadeInUp desktop-footer" data-wow-delay="0.1s"
                                    style={{ zIndex: 11 }}>
                                    <div className="download-footer">
                                        <div className="widget footer-widget">

                                            <h3 className="widget_title">Download our<br /> Application</h3>

                                            <div className="vs-widget-contact">
                                                <div className="col-auto ml-auto">
                                                    <ul className="download-icons" style={{ display: 'block' }}>
    <li style={{ listStyle: 'none' }}>
        <a 
            href="https://play.google.com/store/apps/details?id=com.myjainism" 
            target="_blank" 
            rel="noopener noreferrer"
        >
            <div className="download android">
                <i className="fa-brands fa-google-play fa-3x icon-download"></i>
                <span className="df">Download from</span>
                <span className="dfn">Google Play</span>
            </div>
        </a>
    </li>
    <li style={{ listStyle: 'none' }}>
        <a 
            href="https://apps.apple.com/in/app/my-jainism/id6749439504" 
            target="_blank" 
            rel="noopener noreferrer"
        >
            <div className="download apple">
                <i className="fa-brands fa-apple fa-3x icon-download"></i>
                <span className="df">Download from</span>
                <span className="dfn">App Store</span>
            </div>
        </a>
    </li>
</ul>
                                                </div>

                                            </div>
                                            <div className="mobile-class desktop-footer">
                                                <img className="shape-mockup moving d-none d-lg-block mobile-size"
                                                    src={mobileImage} />
                                            </div>


                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>

                    <div className="footer-copyright">
                        <div className="container footer-new">

                            <p className="copyright">&copy; Copyright © MY JAINISM All Right Reserved.</p>
                            <p className="copyright">Developed By <a href="https://www.absoluteweb.in/" target="_blank" >Absolute web</a></p>

                        </div>
                    </div>
                </footer>
            </React.Fragment >
        );
    }
}

export default Footer;
